import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const SplitAmount: FC<GridCellProps> = (props) => {
  const splitOption = useContextSelector(InvoiceContext, (value) => value.splitOption);
  const { dataItem, dataIndex, field = '', onChange } = props;
  const value = useMemo(() => dataItem[field], [dataItem, field]);

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        syntheticEvent: e.syntheticEvent,
        field: field,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase {...props}>
      <NumberInput
        value={value}
        postfix={splitOption === 'Percentage' ? '%' : ''}
        onChange={handleChange}
      />
    </GridCellBase>
  );
};

export default SplitAmount;
